var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularLightThspian({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 608 608",
    width: 608,
    height: 608,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    id: "f1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,631.981,-631.981,0,304,76.112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff87c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c9449",
    stopOpacity: 0
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { opacity: .6;filter: url(#f1);fill: url(#g1) } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m304 568c-146 0-264-118-264-264 0-146 118-264 264-264 146 0 264 118 264 264 0 146-118 264-264 264z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularLightThspian);
export default __webpack_public_path__ + "static/media/circular_light_thspian.7ca1ebe8d89651a9bf37142119bb6aa4.svg";
export { ForwardRef as ReactComponent };